export default (
  element
) => {
  const { ownerDocument } = element

  if (ownerDocument.contains(element)) {
    element.focus()
  }
}
